import styled from 'styled-components';
import { ArrowRightLong } from '@lt/components/icons-react/userflow';
import { CurrencyFormat } from '@lt/components';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

export const StyledArrowRightLong = styled(ArrowRightLong)`
  margin-right: 5px;
  margin-left: 5px;
  width: 18px;
  transform: rotate(180deg);
`;

export const StyledCurrencyFormat: typeof CurrencyFormat = styled(CurrencyFormat)`
  font-family: 'Backpack', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;

  color: #919499;
`;
